import { CandidateList } from 'pages/common/CandidateList';
import React from 'react';

const Candidates: React.FC = () => {
  return <CandidateList />;
};

export default Candidates;
